import React from 'react';
import './AgreementCheckboxes.scss';
import { documentUrl } from '../../services/documents';
const PRIVACY_POLICY_TEXT = "Я соглашаюсь с";
const PRIVACY_POLICY_LINK_TEXT = "политикой конфиденциальности";
const PERSONAL_DATA_TEXT = "и даю согласие на обработку персональных данных";
const MARKETING_CONSENT_TEXT = "Я даю согласие на получение рекламно-информационных материалов";

interface AgreementCheckboxesProps {
  privacyChecked: boolean;
  onPrivacyChange: (checked: boolean) => void;
  marketingChecked: boolean;
  onMarketingChange: (checked: boolean) => void;
  errorTrigger?: number;
}

const AgreementCheckboxes: React.FC<AgreementCheckboxesProps> = ({
  privacyChecked,
  onPrivacyChange,
  marketingChecked,
  onMarketingChange,
  errorTrigger = 0,
}) => {
  const showError = errorTrigger > 0;
  return (
    <div className="agreement-checkboxes">
      <div key={errorTrigger} className={`agreement-checkboxes__item${showError ? ' agreement-checkboxes__item--error' : ''}`}>
        <label className="agreement-checkboxes__label">
          <input
            type="checkbox"
            checked={privacyChecked}
            onChange={(e) => onPrivacyChange(e.target.checked)}
            className="agreement-checkboxes__input"
            aria-label={`${PRIVACY_POLICY_TEXT} ${PRIVACY_POLICY_LINK_TEXT} ${PERSONAL_DATA_TEXT}`}
          />
          <span className="agreement-checkboxes__text">
            {PRIVACY_POLICY_TEXT} <a href={documentUrl('policy')} target="_blank" rel="noopener noreferrer">{PRIVACY_POLICY_LINK_TEXT}</a> {PERSONAL_DATA_TEXT}
          </span>
        </label>
      </div>
      <div className="agreement-checkboxes__item">
        <label className="agreement-checkboxes__label">
          <input
            type="checkbox"
            name="allow_marketing"
            checked={marketingChecked}
            onChange={(e) => onMarketingChange(e.target.checked)}
            className="agreement-checkboxes__input"
            aria-label={MARKETING_CONSENT_TEXT}
          />
          <span className="agreement-checkboxes__text">
            Я даю <a href={documentUrl('newsletter')}>согласие на получение новостной и рекламной рассылки</a>
          </span>
        </label>
      </div>
    </div>
  );
};

export default AgreementCheckboxes;
